import { IRadioDropdownOption } from '../components/shared/radio-dropdown/radio-dropdown';
import { getKeyByValue } from '../utils/helpers/polls-helper';

export const ITERATE_NUMBER = 1;
export const MAX_POLLS_LIST_SIZE = 100;
export const MAX_RESPONSES_LIMIT = 20;
export const POLLS_LIST_LIMIT_MESSAGE = `<p>Poll cannot be saved because the maximum has been reached <b>(${MAX_POLLS_LIST_SIZE})</b>.</p>`;
export const POLLS_RESPONSES_LIMIT_MESSAGE = `<p>Response cannot be saved because the maximum has been reached <b>(${MAX_RESPONSES_LIMIT})</b>.</p>`;
export const LEFT_COORDINATS_SUM_PX = 25;
export const MOBILE_ELIPSIS_LEFT_CORRECTION = 107;
export const MOBILE_ELIPSIS_TOP_CORRECTION = 30;
export const MOBILE_ELIPSIS_TOP_CORRECTION_MOBILE = 20;
export const DEFAULT_STREAM_ADJUSTMENT = 30;
export const MILLI = 1000;
export const ADDITIONAL_DELTA = 100;
export const EMPTY_LIST_TEXT = 'There are no Polls.';
export const CREATE_POLL_BUTTON_TEXT = 'Create Poll';
export const NUMBER_OF_RETRIES = 10;
export const DELAY = 5000;
// Fragment of the backend guard "Command could not be processed as live presentation is already ended."
// which rejects every poll command once the broadcast reaches the Ended status. The API answers with a
// plain 400 carrying no distinguishing error code, so this text is the only handle available. It is owned
// by AbstractCommandStrategy.processCommandBasedOnLiveStatus in KV-API (content-api) — rewording it there
// silently reverts the Hide Results recovery in PollsStore.sharePollResults to leaving the poll stuck.
export const LIVE_ENDED_ERROR_MESSAGE_PART = 'already ended';
// Shown when a reset has to be abandoned because the shared-results flag could not be cleared first —
// see PollsStore.resetPoll for why finishing the reset anyway would lock the whole polls list.
export const RESET_SHARED_RESULTS_ERROR_MESSAGE = '<p>This poll could not be reset because its results are still shared with viewers. Please try again.</p>';
// Shown when the automatic hide after the live ends fails to write. Nothing retries it — the broadcast is
// over, so there is no further status change to react to — and the presenter would otherwise never learn
// the results are still on viewers' screens. Reloading is the retry offered: the API rejects every poll
// command once the live has ended, so no button can be pointed at, while a fresh load re-runs the clear
// through getPollsList -> hideSharedResultsOnLiveEnded, which writes via updatePoll and issues no command.
export const HIDE_SHARED_RESULTS_ON_LIVE_ENDED_ERROR_MESSAGE = '<p>The live presentation has ended. Please refresh the page to try again.</p>';

export enum PollsViewStatuses {
  NOT_STARTED = 'Not Started',
  IN_PROGRESS = 'In Progress',
  COMPLETED = 'Completed',
  RESETED = 'RESETED'
}

export enum PollsTypes {
  MULTIPLE_CHOICE = 'Multiple Choice',
  RATINGS = 'Ratings',
  FREEFOR_TEXT_FIELD = 'Freeform text field',
  MULTIPLE_SELECT = 'Multiple select'
}

export type TPollStatus = keyof typeof PollsViewStatuses;
export type TPollType = keyof typeof PollsTypes;

export enum PresenterVisibility {
  HIDDEN = 'Hidden from Presenter',
  VISIBLE = 'Visible to Presenter'
}

export enum ManagePollActions {
  RESPONSE_TYPE = 'response-type',
  PRESENTER_VISIBLE = 'presenter-visible'
}

export enum PollChoiceStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED'
}

export const responseTypeOptions: IRadioDropdownOption[] = [
  { id: 1, title: PollsTypes.MULTIPLE_CHOICE, disabled: false, value: PollsTypes.MULTIPLE_CHOICE },
  { id: 2, title: PollsTypes.RATINGS, disabled: true, value: PollsTypes.RATINGS },
  { id: 3, title: PollsTypes.FREEFOR_TEXT_FIELD, disabled: true, value: PollsTypes.FREEFOR_TEXT_FIELD },
  { id: 4, title: PollsTypes.MULTIPLE_SELECT, disabled: true, value: PollsTypes.MULTIPLE_SELECT },
];

export const presenterVisibleOptions: IRadioDropdownOption[] = [
  { id: 1, title: PresenterVisibility.HIDDEN, value: 1 },
  { id: 2, title: PresenterVisibility.VISIBLE, value: 0 },
];

export const defaultPollPropreties = {
  status: getKeyByValue(PollsViewStatuses, PollsViewStatuses.NOT_STARTED) as TPollStatus,
  type: getKeyByValue(PollsTypes, PollsTypes.MULTIPLE_CHOICE) as TPollType,
  hideForPresenter: true,
  isSlideAdded: false,
  countVotes: 0,
  value: '',
  command: '',
  publicAdjustment: 0,
  result_slide_added: false
};

export enum EllipsisMenu {
  EDIT = 'Edit',
  DELETE = 'Delete',
  REOPEN = 'Reopen poll',
  RESET = 'Reset results'
}

export enum PollCommands {
  START_POLL = 'START_POLL',
  STOP_POLL = 'STOP_POLL'
}

export enum PollsTabsOnMobile {
  LIST = 'All Polls',
  DETAILS = 'Poll Details'
}

export enum FullScreenButtonContent {
  OPEN = 'Present in Full Screen',
  EXIT = 'Exit Full Screen'
}

export enum PollResultsSlideContent {
  RESULTS_SLIDE_ADDED = 'Results slide added',
  ADD_RESULT_SLIDE = 'Add Results Slide',
  TYPE_SLIDE = 'slide',
}

export enum PollResultsShareContent {
  SHOW_RESULTS = 'Show Results',
  HIDE_RESULTS = 'Hide Results',
}